import Nav from "@/components/sections/Nav";
import Hero from "@/components/sections/Hero";
import Comparison from "@/components/sections/Comparison";
import HowItWorks from "@/components/sections/HowItWorks";
import TestingTypes from "@/components/sections/TestingTypes";
import Exploratory from "@/components/sections/Exploratory";
import FeatureGrid from "@/components/sections/FeatureGrid";
import Vision from "@/components/sections/Vision";
import FinalCTA from "@/components/sections/FinalCTA";
import Footer from "@/components/sections/Footer";

export default function Landing() {
  return (
    <div data-testid="landing-page" className="relative min-h-screen bg-background text-foreground overflow-x-hidden">
      <Nav />
      <main>
        <Hero />
        <Comparison />
        <HowItWorks />
        <TestingTypes />
        <Exploratory />
        <FeatureGrid />
        <Vision />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
